<template>
    <div class="panel-section panel-section-2">
        <section class="device-bar">
            <div @click="toggleDeviceDetailsPanel()" style="width: 100%;">
                <span class="device-status">
                    <i class="fas fa-circle fa-xs"
                       :class="[$store.state.config.deviceStatusClass[device.state]]"
                       aria-hidden="true"></i>
                </span>
                <span class="device-status">
                    <i class="fas fa-plug fa-sm icon-danger" v-show="device.batteryWarning"
                       aria-hidden="true" :title="$t('device_details.battery_warning')"></i>
                </span>
                <span class="device-status">
                    <i class="fas fa-lock fa-sm" :class="{'icon-warning': alarmActive}"
                       v-show="device.moveAlarmSettings.alarm.find(item => item.type === 'continuous').enabled || device.moveAlarmSettings.alarm.find(item => item.type === 'limited').enabled" aria-hidden="true"
                       :title="alarmActive ? $t('alarm.alarm_active') : $t('alarm.alarm_enabled_inactive')"></i>
                </span>
                <span class="device-status device-label1" :title="'ID: ' + device.id + ' - ' + device.label">{{ device.label }}
                </span>
                <span class="device-status device-label2" :title="device.label2">{{ device.label2 }}</span>
            </div>
            <i class="fas fa-times close-button" @click="backToList()"></i>
        </section>

        <hr :class="'group group'+device.group"/>

        <section class="grows">
            <b-tabs class="tabs-bar" type="is-boxed" size="is-small" @input="changeTab" v-model="tabIndex" expanded>
                <b-tab-item :label="$t('device_details.info')" icon="info" v-touch:swipe="handleSwipe">
                    <perfect-scrollbar>
                        <div class="tab-item-content">
                            <Info></Info>
                        </div>
                    </perfect-scrollbar>
                </b-tab-item>
                <b-tab-item :label="$t('device_details.alarm')" icon="bell" v-touch:swipe="handleSwipe">
                    <perfect-scrollbar>
                        <div class="tab-item-content">
                            <Alarm></Alarm>
                        </div>
                    </perfect-scrollbar>
                </b-tab-item>
                <b-tab-item :label="$t('device_details.mvb')" icon="file-alt" v-touch:swipe="handleSwipe">
                    <div class="tab-item-content">
                        <VehicleReport></VehicleReport>
                    </div>
                </b-tab-item>
                <b-tab-item :label="$t('device_details.history')" icon="history" v-touch:swipe="handleSwipe">
                    <perfect-scrollbar>
                        <div class="tab-item-content">
                            <History></History>
                        </div>
                    </perfect-scrollbar>
                </b-tab-item>
            </b-tabs>
        </section>
    </div>
</template>

<script>
import Info from './Info';
import Alarm from './Alarm';
import History from './History';
import VehicleReport from './VehicleReport';

export default {
    name: 'DeviceDetails',
    components: { Info, Alarm, History, VehicleReport },
    data() {
        return {
            tabIndex: 0,
            deviceStatusClass: ['hidden', 'has-text-grey-light', 'has-text-success', 'has-text-danger', 'has-text-warning']
        };
    },
    methods: {
        backToList() {
            this.$store.commit('selectedDeviceIndex', -1);
            this.$store.commit('map/followDevice', -1);
            this.$store.commit('DevicePanelActive', 0);
            this.$store.dispatch('deviceDetailsPanelMinimized', false);
        },
        changeTab(index) {
            this.$store.dispatch('deviceDetailsPanelMinimized', false);
            const minIndex = 0;
            const maxIndex = 3;

            if (index < minIndex) {
                this.backToList();
                index = minIndex;
            }

            if (index === 2) {
                this.$store.commit('devicePanelFullScreen', true);
                this.$root.$emit('getVehicleReport');
            } else {
                this.$store.commit('devicePanelFullScreen', false);
            }

            if (index === 3) {
                this.$store.dispatch('deviceDetailsPanelMinimized', false);
                this.$root.$emit('getDeviceHistory');
            } else {
                // Clear history lines on the map.
                this.$store.dispatch('map/clearHistorySessions');

                // Reload markers
                this.$store.commit('map/reloadMarkers');
            }

            if (index > maxIndex) {
                index = maxIndex;
            }

            this.tabIndex = index;
        },
        handleSwipe(direction, el) {
            if (this.tabIndex === 2) {
                // Prevent user from swiping on MVB table.
                // Check for id: vehicle-report-table
                for (let p of el.path) {
                    if (p.id === 'vehicle-report-table') {
                        return;
                    }
                }
            }

            if (direction === 'bottom') {
                this.$store.dispatch('deviceDetailsPanelMinimized', true);
                return;
            }

            let index = this.tabIndex;
            if (direction === 'left') {
                index += 1;
            } else if (direction === 'right') {
                index -= 1;
            }

            this.changeTab(index);
        },
        toggleDeviceDetailsPanel() {
            let minimized = this.$store.state.ui.deviceDetailsPanelMinimized;
            this.$store.dispatch('deviceDetailsPanelMinimized', !minimized);
        }
    },
    computed: {
        device: function() {
            return this.$store.getters.selectedDevice;
        },
        alarmActive: function() {
            return this.$store.getters.alarmActive;
        }
    }
};
</script>

<style lang="scss">
    hr {
        margin: 0.2em 0 0.3em 0;

        &.group {
            border-bottom: 4px solid;

            &.group1 {
                border-bottom-color: $group1;
            }

            &.group2 {
                border-bottom-color: $group2;
            }

            &.group3 {
                border-bottom-color: $group3;
            }

            &.group4 {
                border-bottom-color: $group4;
            }

            &.group5 {
                border-bottom-color: $group5;
            }

            &.group6 {
                border-bottom-color: $group6;
            }

            &.group7 {
                border-bottom-color: $group7;
            }

            &.group8 {
                border-bottom-color: $group8;
            }

            &.group9 {
                border-bottom-color: $group9;
            }
        }
    }

    .grows {
        flex: 1;
        width: 100%;
        padding-bottom: 0.2em;
        align-content: start;
        min-height: 0;
    }

    .device-bar {
        height: 2.5rem;
        line-height: 2.4rem;
        display: flex;
        flex-wrap: wrap;
        width: 95%;
        margin-top: auto;
        margin-bottom: auto;
        padding: 0.15rem 0.6rem;

        span {
            display: block;
            float: left;
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .device-status {
            margin-top: auto;
            margin-bottom: auto;
        }
        .device-status:not(:first-child) i {
            margin-left: 0.5em;
        }

        .device-label1,
        .device-label2 {
            margin-left: 0.5em;
        }

        .device-label1 {
            max-width: 80%;
        }

        .device-label2 {
            color: $grey-light;
        }
    }

    .device-info {
        display: flex;
        margin-top: 0.4rem;
        margin-bottom: 0.4rem;

        .toolbar-button {
            margin: auto;
            width: 4rem;
            text-align: center;
        }

        .vr {
            margin-right: 0;
        }
    }

    .icon-danger {
        color: $danger;
    }

    .icon-warning {
        color: $warning;
    }

    .tabs-bar {
        > .tabs ul li a {
            padding-top: 0.4rem !important;
            padding-bottom: 0.4rem !important;
        }

        .tabs {
            flex: 0 0 auto;

            a {
                padding: 0.2em 0.5em;
            }

            ul {
                justify-content: center;
                border-bottom: none;
            }
        }

        .tabs.is-boxed li.is-active a {
            background-color: unset;
            border: none;
        }
    }

    .b-tabs {
        flex-direction: column-reverse; //reverse
        display: flex;
        height: 100%;

        .tabs {
            flex: 0 0 auto;
            margin-top: auto;
        }
    }

    .b-tabs .tab-content {
        padding: 0;
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;

        .tab-item,
        .tab-item > div {
            height: 100%;
            background-color: $panel-black;
        }

        .tab-item .tab-item-content {
            padding: 0.15rem 0.6rem;
        }
    }

    section {
        display: block;
    }

    @media screen and (max-width: 500px) {
        .device-bar,
        .b-tabs .tab-content .tab-item .tab-item-content {
            padding: 0.15rem 0.8rem;
        }
    }
    /*
    .tab-item {
        .timepicker {
            .timepicker .dropdown-content .control.is-colon {
                line-height: 25px;
                height: 35px;
            }

            .select select {
                height: 35px;
                line-height: 15px;
                padding: 0.4rem;
                padding-left: 0.5rem !important;
                padding-right: 0.5rem !important;
            }
        }

        .datepicker-header {
            a.pagination-previous,
            a.pagination-next,
            .select,
            .select select {
                line-height: 15px;
                height: 30px;
            }
        }
    }
    */
</style>
